
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as ModelPrincipal } from '@view/a-pedidos-ml/controlador';
    import { Controlador as Model } from '@view/a-pedidos-ml/pc/lista/controlador';
    import buscador from './lista-buscador.vue';
    import opciones_listado from './lista-buscador-opciones-listado.vue';
    import cuentas from './lista-buscador-cuentas.vue';
    import listado from './lista-listado.vue';
    import filtros_activos from './lista-buscador-filtros-activos.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            buscador,
            listado,
            filtros_activos,
            cuentas,
            opciones_listado
        }
    } )
    export default class Componente extends Vue
    {
        public get Principal() { return Vue.observable( ModelPrincipal ); }
        public get Controlador() { return Vue.observable( Model ); }
        public get Buscador() { return this.Controlador.Buscador; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            this.Controlador.Buscador.Filtros.set( this.$route.query );
            this.Controlador.Buscador.Buscar();

        }


    }
